module.exports = __webpack_public_path__ + "assets/img/zh-Hant-62ccd2e9.png";